<script setup>
// import $ from "jquery";
import { onMounted, ref, computed } from "vue";
import { getEnergyProportion } from "@/api/common";
// import { useRouter } from "vue-router";
// let $ul;
// let timeID;
let lis = ref([]);
// const { currentRoute } = useRouter();
// const router = currentRoute.value
onMounted(() => {
  getEnergyProportion().then((res) => {
    if (res.success) {
      lis.value = res.data.energys;
      // if (res.data.length > 3) {
      //     $ul = $('#roll');
      //     roll()
      // }
    }
  });
});
const farmater = computed(() => (num) => {
  let value = parseFloat(num);
  if (value) {
    return new Intl.NumberFormat('en-IN').format(value)
  } else {
    return num
  }
})

// function roll() {
//     clearInterval(timeID);
//     timeID = setInterval(function () {
//         clearInterval(timeID);
//         $ul.animate({ top: "0px" }, 1000, function () {
//             $ul.find("li:first").removeClass().addClass('roll_hide').appendTo($ul);

//             for (var i = 0; i < 4; i++) {
//                 $ul.find("li").eq(i).removeClass().addClass('roll_' + i)
//             }
//             roll()
//         })
//     }, 3000);
// }
</script>

<template>
  <ul class="list" v-if="lis.length">
    <!-- <li v-for="(item, index) in lis" :key="index" :class="index < 4 ? 'roll_' + index : 'roll_hide'">
            <span class="colorWhite">{{ item.cropName }}</span>
            <span>
                <b class="ml-20 colorLG fz-lg">{{ item.grainsThousandth }}</b>
                <b class="colorWhite fz-sm">粒</b>
            </span>
        </li> -->
    
     <li v-for="(item, index) in lis" :key="index">
      <span class="colorWhite"><i class="iconfont icon-lengku mr-5 fz-md"></i>{{ item.name }}</span>
      <b class="ml-10 mr-5 colorLG fz-lg">{{ farmater(item.value) }}</b>
      <span class="colorWhite fz-sm">kW.h</span>
      <!-- <div class="border-image"></div> -->
    </li>
    <!-- <li>
      <span class="colorWhite"><i class="iconfont icon-jixiangfengshan mr-5 fz-md"></i>{{ lis[1].name }}</span>
      <b class="ml-10 mr-5 colorLG fz-lg">{{ farmater(lis[1].value) }}</b>
      <span class="colorWhite fz-sm">kW.h</span>
      <div class="border-image"></div>
    </li>  -->
   
    <!-- <li>
      <span class="colorWhite"><i class="iconfont icon-chushiji mr-10 fz-md"></i>干燥设备</span>
      <b class="ml-20 colorLG fz-lg">{{ farmater(lis[2].value) }}</b>
    </li> -->
    <!-- <li v-for="(item,index) in lis" :key="index">
      <div class="colorWhite"><b>{{ item.name }}</b></div>
      <div class="align-right">
        <b class="ml-10 mr-5 colorLG fz-lg">{{ farmater(item.value) }}</b>
        <span class="colorWhite fz-sm">kW.h</span>
      </div>
      <div class="border-image"></div>
    </li> -->
  </ul>
</template>

<style lang="scss" scoped>
.list {
  width: 90%;

  li {
    position: relative;
    padding: 10px 0;
    // height: 70px;
    // line-height: 70px;
    // border-bottom: 1px solid #fff;
  }
}

.border-image {
  background-image: linear-gradient(90deg, rgba(0, 252, 252, 0) 0%, rgba(255, 255, 255, 0.73) 54%, rgba(0, 252, 252, 0) 100%);
}

// .roll {
//     position: relative;
//     width: 100%;
//     height: 100%;
//     margin-left: 20px;
//     overflow: hidden;
// }

// .roll li {
//     display: flex;
//     justify-content: space-between;
//     width: 100%;
//     position: absolute;
//     left: 0;
//     transition: all 2s;
//     font-size: 18px;
//     list-style: none;
// }

// .roll li.roll_0 {
//     // opacity: 0.5;
//     top: 0;
//     /* font-size:10px; */
// }

// .roll li.roll_1 {
//     // opacity: 0.8;
//     top: 80px;
//     /* font-size:14px; */
// }
</style>
